<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          color="primary"
          @click="handleCreateSchedule"
        >
          Create Schedule
        </v-btn>
      </v-col>
      <v-col class="text-right">
        <div class="d-flex justify-end align-baseline">
          <v-btn
            color="primary"
            outlined
            @click="handleClickToday"
          >
            Today
          </v-btn>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            class="ml-3"
            @click="handlePrev"
          >
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            class="mr-3"
            @click="handleNext"
          >
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <span
            v-if="$refs.calendar"
            class="mr-5"
          >
            {{ $refs.calendar.title }}
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row class="fill-height">
      <v-col>
        <v-sheet height="600">
          <v-calendar
            ref="calendar"
            v-model="today"
            :events="events"
            :type="types[type]"
          >
            <template #event="{ event }">
              <div
                class="mx-2"
                @click="updateOrSeeSchedule(event)"
              >
                {{ formatDisplaySchedule(event) }}
              </div>
            </template>
          </v-calendar>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog"
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">
          {{ isEdit ? 'Update' : (isSee ? '' : 'Create') }} Schedule
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container
            fluid
            class="px-0 py-0"
          >
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="event.vehicle_id"
                  :items="vehicles"
                  item-text="device_name"
                  item-value="id"
                  label="Vehicle"
                  outlined
                  hide-details
                  :disabled="isSee"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="event.note"
                  label="Note"
                  outlined
                  hide-details
                  :disabled="isSee"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  ref="start_date"
                  v-model="event.start_date"
                  label="Start Date"
                  type="datetime-local"
                  :min="currentDate"
                  outlined
                  hide-details
                  clearable
                  :disabled="isSee"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  ref="end_date"
                  v-model="event.end_date"
                  label="End Date"
                  type="datetime-local"
                  :min="currentDate"
                  outlined
                  hide-details
                  clearable
                  :disabled="isSee"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-space-between mx-2 py-5">
          <v-btn
            color="red"
            @click="handleDeleteService"
            v-if="isEdit"
            class="text-light"
          >
            Delete
          </v-btn>
          <div>
            <v-btn
              color="light"
              @click="dialog = false"
              class="mr-2"
            >
              {{ isSee ? 'Close' : 'Cancel' }}
            </v-btn>
            <v-btn
              color="primary"
              @click="saveEvent"
              v-if="!isSee"
            >
              Submit
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment';
import { isEmpty, isNull } from 'lodash';

const today = moment(new Date()).format('YYYY-MM-DD');

export default {
  data: () => ({
    today,
    type: 'Month',
    types: {
      Day: 'day',
      Week: 'week',
      Month: 'month',
      '4 Days': '4day',
    },
    vehicles: [],
    events: [],
    isEdit: false,
    isSee: false,
    event: {
      id: '',
      vehicle_id: '',
      note: '',
      start_date: moment().format('YYYY-MM-DD HH:mm'),
      end_date: moment().format('YYYY-MM-DD HH:mm'),
    },
    dialog: false,
    query: {
      start_date: moment().startOf('month').format('YYYY-MM-DD'),
      end_date: moment().endOf('month').format('YYYY-MM-DD'),
    }
  }),
  created() {
    this.fetchVehicles();
  },
  computed: {
    clientid() {
      return this.$store.state.clientid;
    },
    currentDate() {
      return moment(this.today).format('YYYY-MM-DDTHH:mm:ss');
    },
  },
  methods: {
    fetchVehicles() {
      this.$store.dispatch('API_CALL', {
          $method: 'get_vehicles',
          $postData: {
            clientid: this.clientid
          },
        })
        .then((response) => {
          this.vehicles = response.data.data.filter(
            (vehicle) =>
              !isEmpty(vehicle.type_id) && !isNull(vehicle.type_id)
          );
          this.refreshVehicleServices();
        });
    },
    fetchVehicleServices() {
      const startQueryDate = moment(this.query.start_date).format('YYYY-MM-DD 00:00:00');
      const endQueryDate = moment(this.query.end_date).format('YYYY-MM-DD 23:59:59');
      this.$store.dispatch('API_CALL', {
        $method: 'get_vehicle_services',
        $postData: {
          clientid: this.clientid,
          start_date: startQueryDate,
          end_date: endQueryDate
        },
      })
      .then((response) => {
        this.events = response.data.data.map((event) => {
          const vehicle = this.vehicles.find((vehicle) => parseInt(vehicle.id) === parseInt(event.vehicle_id));
          return {
            id: event.id,
            name: vehicle ? vehicle.device_name : 'Unknown',
            vehicle_id: event.vehicle_id,
            note: event.note,
            start: moment(event.start_date).format('YYYY-MM-DD HH:mm'),
            end: moment(event.end_date).format('YYYY-MM-DD HH:mm')
          };
        });
      })
    },
    refreshVehicleServices() {
      this.$nextTick(() => {
        this.query.start_date = moment(this.$refs.calendar.lastStart.date).format('YYYY-MM-DD 00:00:00');
        this.query.end_date = moment(this.$refs.calendar.lastEnd.date).format('YYYY-MM-DD 23:59:59');
        this.fetchVehicleServices();
      });
    },
    handleClickToday() {
      this.today = new Date();
      this.refreshVehicleServices();
    },
    handlePrev() {
      this.$refs.calendar.prev();
      this.refreshVehicleServices();
    },
    handleNext() {
      this.$refs.calendar.next();
      this.refreshVehicleServices();
    },
    handleCreateSchedule() {
      this.dialog = true;
      this.isEdit = false;
      this.isSee = false;
      this.event = {
        id: '',
        vehicle_id: '',
        note: '',
        start_date: moment().format('YYYY-MM-DD HH:mm'),
        end_date: moment().format('YYYY-MM-DD HH:mm'),
      };
    },
    saveEvent() {
      const start_date = moment(this.event.start_date).format('YYYY-MM-DD HH:mm:00');
      const end_date = moment(this.event.end_date).format('YYYY-MM-DD HH:mm:00');

      if (this.event.vehicle_id === '') {
        this.$swal('Error', 'Please Select Vehicle', 'error');
        return;
      }

      if ((start_date === '' || start_date == 'Invalid date') || (end_date === '' || end_date == 'Invalid date')) {
        this.$swal('Error', 'Please Select Start Date and End Date', 'error');
        return;
      }

      const payload = {
        vehicle_id: this.event.vehicle_id,
        note: this.event.note,
        start_date,
        end_date
      }

      let method = 'create_vehicle_service';

      if (this.isEdit) {
        payload.id = this.event.id;
        method = 'update_vehicle_service';
      }

      this.$store.dispatch('API_CALL', {
          $method: method,
          $postData: {
            data: payload
          },
        })
        .then((response) => {
          if (!response.data.error) {
            this.refreshVehicleServices();
          }
          const isSuccess = response.data.error ? 'Error' : 'Success';
          this.$swal(isSuccess, response.data.message, isSuccess.toLowerCase());
          this.dialog = false;
        });
    },
    handleDeleteService() {
      this.$swal({
        title: 'Are you sure want to delete this schedule?',
        icon: 'warning',
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true,
        dangerMode: true,
      }).then(({ isConfirmed }) => {
        if (isConfirmed) {
          this.$store.dispatch('API_CALL', {
              $method: 'delete_vehicle_service',
              $postData: {
                id: this.event.id
              },
            })
            .then((response) => {
              if (!response.data.error) {
                this.refreshVehicleServices();
              }
              const isSuccess = response.data.error ? 'Error' : 'Success';
              this.$swal(isSuccess, response.data.message, isSuccess.toLowerCase());
              this.dialog = false;
            });
        }
      });
    },
    formatDisplaySchedule(event) {
      let format = ''
      if (event.name) format = event.name;
      if (event.note) format += ` • ${event.note}`;
      const startDate = moment(event.start).format('YYYY-MM-DD');
      const endDate = moment(event.end).format('YYYY-MM-DD');
      if (startDate == endDate) {
        format += ` • ${moment(event.start).format('HH:mm')} - ${moment(event.end).format('HH:mm')}`;
      } else {
        format += ` • ${moment(event.start).format('DD MMM YYYY HH:mm')} - ${moment(event.end).format('DD MMM YYYY HH:mm')}`;
      }
      return format;
    },
    updateOrSeeSchedule(event) {
      this.dialog = true;
      if (moment().isAfter(event.end)) {
        this.isEdit = false;
        this.isSee = true;
      } else {
        this.isEdit = true;
        this.isSee = false;
      }
      this.event = {
        id: event.id,
        vehicle_id: event.vehicle_id,
        note: event.note,
        start_date: moment(event.start).format('YYYY-MM-DD HH:mm'),
        end_date: moment(event.end).format('YYYY-MM-DD HH:mm'),
      };
    },
  },
  watch: {
    'event.start_date': function (val) {
      if (val > this.event.end_date) {
        this.event.end_date = val;
      }
    },
    'event.end_date': function (val) {
      if (val < this.event.start_date) {
        this.event.start_date = val;
      }
    },
    type() {
      this.refreshVehicleServices();
    }
  }
}
</script>